import React, { useEffect, useState } from 'react';
export function Timer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 51
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center py-4" data-id="element-298">
      <p className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-6" data-id="element-299">
        ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
      </p>

      {/* Big bright red countdown with soft red glow behind */}
      <div className="relative flex items-center justify-center mb-8" data-id="element-300">
        <div className="absolute inset-0 bg-[#FF1744]/15 blur-2xl rounded-full pointer-events-none scale-150" data-id="element-301"></div>
        <div className="text-6xl sm:text-7xl lg:text-8xl font-black font-mono tracking-wider flex items-center justify-center gap-2 sm:gap-3 relative z-10" style={{
        color: '#FF1744',
        textShadow: '0 0 40px rgba(255,23,68,0.6), 0 0 80px rgba(255,23,68,0.3)'
      }} data-id="element-302">
          <span data-id="element-303">{format(timeLeft.hours)}</span>
          <span className="opacity-50 pb-2 sm:pb-4" data-id="element-304">:</span>
          <span data-id="element-305">{format(timeLeft.minutes)}</span>
          <span className="opacity-50 pb-2 sm:pb-4" data-id="element-306">:</span>
          <span data-id="element-307">{format(timeLeft.seconds)}</span>
        </div>
      </div>

      <div className="max-w-2xl flex flex-col items-center gap-2" data-id="element-308">
        <p className="font-bold text-white text-base sm:text-lg flex items-center justify-center flex-wrap gap-x-2" data-id="element-309">
          <span className="text-brand-orange text-xl" data-id="element-310">⚠️</span>
          <span data-id="element-311">Después sube</span>
          <span className="font-black" style={{
          color: '#FF1744'
        }} data-id="element-312">
            $8.000 ARS
          </span>
        </p>
        <p className="font-bold text-white text-base sm:text-lg" data-id="element-313">
          No vuelve al precio actual.
        </p>

        <div className="bg-white/10 rounded-full h-3 w-full max-w-md overflow-hidden mt-4 mb-1" data-id="element-314">
          <div className="h-full rounded-full w-[71%]" style={{
          backgroundColor: '#FF1744',
          boxShadow: '0 0 15px rgba(255,23,68,0.6)'
        }} data-id="element-315"></div>
        </div>
        <p className="text-sm font-extrabold" style={{
        color: '#FF1744'
      }} data-id="element-316">
          🔴 71% de los cupos al precio de lanzamiento ya tomados
        </p>
      </div>
    </div>;
}